export default __webpack_public_path__ + "static/healthcare-page-resource-img-2-0224899cfd1cce997a0eda621ec52dd0.svg";